import { User } from '@mews-commander/data-access';
import { useIsUserProvisioned } from '../userManagement/hooks/useIsUserProvisioned';
import { ProfileFormProps } from './components/Profile/ProfileForm/ProfileForm';
import { ProfileFormValues } from './components/Profile/ProfileForm/types';

const mapUserToProfileFormValues = (user: User): ProfileFormValues => ({
    userId: user.userId || null,
    firstName: user.firstName || null,
    lastName: user.lastName || null,
    secondLastName: user.secondLastName || null,
    primaryMailAddress: user.primaryMailAddress || null,
    titlePrefix: user.titlePrefix || null,
    sex: user.sex || null,
    birthDate: user.birthDate || null,
    birthPlace: user.birthPlace || null,
    telephone: user.telephone || null,
    preferredLanguageCode: user.preferredLanguageCode || null,
    preferredCultureCode: user.preferredCultureCode || null,
    nationalityCode: user.nationalityCode || null,
    defaultProfileId: user.profiles?.find((p) => p.isDefault)?.profileId || null,
});

export const useMapUserToProfileFormProps = (user?: User): ProfileFormProps => {
    const isUserProvisioned = useIsUserProvisioned(user);

    if (!user) {
        return {} as ProfileFormProps;
    }

    return {
        defaultValues: mapUserToProfileFormValues(user),
        isUserProvisioned,
    };
};
